import { Box, HStack, PresenceTransition, Text } from 'native-base';
import React from 'react';
import Functions from '../../../utils/Functions';
import { ColoredDifferenceAmount } from '../index';
const ExpandableSummarySubRow = _ref => {
  let {
    isOpen,
    title,
    previous,
    current,
    difference
  } = _ref;
  return /*#__PURE__*/React.createElement(PresenceTransition, {
    key: title,
    visible: isOpen,
    initial: {
      opacity: 0,
      scale: 0
    },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 250
      }
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    h: "16",
    bg: "#F1F4F7",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#cccccc",
    testID: `row-${title}`,
    pl: [4, 10, 10],
    pr: [4, 20, 20],
    pt: "5",
    alignItems: "baseline"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 2,
    position: "relative",
    left: [4, 10, 10],
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: title,
    accessibilityRole: "text"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: Functions.toUSD(previous),
    accessibilityRole: "text"
  }, Functions.toUSD(previous))), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    accessibilityLabel: Functions.toUSD(current),
    accessibilityRole: "text"
  }, Functions.toUSD(current)), /*#__PURE__*/React.createElement(ColoredDifferenceAmount, {
    difference: difference,
    key: 'twenty-five',
    id: 'twenty-five'
  }))));
};
export default ExpandableSummarySubRow;
//# sourceMappingURL=index.js.map